import { parseLink } from 'ricos-content/libs/nodeUtils';
import { getAnchorableNodesQuery } from 'ricos-content-query';
import { convertRelStringToObject, convertRelObjectToString } from 'wix-rich-content-common/libs/linkConverters';
import { getAnchorableBlocksFromAnchorableNodes } from './anchorAdapter.js';
import 'ricos-schema';
import './helpers.js';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const handleLinkSettings = (linkSettings) => {
  const { anchorTarget = "_blank", customAnchorScroll } = linkSettings;
  let { relValue, rel } = linkSettings;
  const defaultRel = "noreferrer";
  relValue = (relValue == null ? void 0 : relValue.includes(defaultRel)) ? relValue : relValue + ` ${defaultRel}`;
  rel = convertRelStringToObject(relValue);
  relValue = convertRelObjectToString(rel);
  return { relValue, anchorTarget, customAnchorScroll };
};
const getLinkFromRawData = (rawLinkData) => {
  let linkData = { customData: rawLinkData == null ? void 0 : rawLinkData.customData };
  if (rawLinkData) {
    const { anchor, url } = rawLinkData;
    if (url) {
      const { url: url2 = "", rel = "", target = "_self" } = parseLink(rawLinkData);
      linkData = __spreadProps(__spreadValues({}, linkData), { url: url2, rel, target });
    } else if (anchor) {
      linkData = __spreadProps(__spreadValues({}, linkData), { anchor });
    }
  }
  return linkData;
};
const getAnchorableBlocks = (experiments, contentQueryService, editorCommands) => {
  var _a;
  if ((_a = experiments.tiptapEditor) == null ? void 0 : _a.enabled) {
    const contentExtractor = contentQueryService.getContentExtractor();
    if (contentExtractor) {
      const selectedNodeId = editorCommands.getSelection().startKey;
      const anchorableNodes = getAnchorableNodesQuery(contentExtractor, selectedNodeId);
      return getAnchorableBlocksFromAnchorableNodes(anchorableNodes);
    }
  } else {
    return editorCommands == null ? void 0 : editorCommands.getAnchorableBlocks();
  }
};
const getLinkModalProps = (editorCommands, linkSettings, contentQueryService, experiments) => {
  const rawLinkData = editorCommands == null ? void 0 : editorCommands.getLinkDataInSelection();
  const linkData = getLinkFromRawData(rawLinkData);
  const getAnchorableBlocksFn = () => getAnchorableBlocks(experiments, contentQueryService, editorCommands);
  const linkSettingsData = handleLinkSettings(linkSettings);
  return { linkData, getAnchorableBlocksFn, linkSettingsData };
};

export { getLinkModalProps };
//# sourceMappingURL=utils.js.map
